<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm" (click)="onClose()">
  <div class="relative w-full max-w-3xl bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 flex flex-col max-h-[90vh]"
    (click)="$event.stopPropagation()">

    <div *ngIf="isLoading()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <ng-container *ngIf="detail as d">
      <div class="flex-none px-6 md:px-8 py-5 border-b border-slate-100 dark:border-slate-800 flex items-start justify-between gap-4">
        <div>
          <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2 flex-wrap">
            <span class="material-icons text-amber-500">confirmation_number</span>
            {{ d.name }}
            <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold" [ngClass]="statusBadgeClass(d.status)">
              {{ statusLabel(d.status) }}
            </span>
          </h3>
          <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">รายละเอียด Advance (โควต้า)</p>
        </div>
        <button type="button" (click)="onClose()" [disabled]="isExporting()"
          class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors shrink-0">
          <span class="material-icons">close</span>
        </button>
      </div>

      <div class="flex-1 overflow-y-auto px-6 md:px-8 py-6 custom-scrollbar space-y-6">
        <div class="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
          <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-800/50">
            <div class="text-xs text-slate-400 font-bold uppercase mb-1">ร้าน</div>
            <div class="font-bold text-slate-800 dark:text-slate-100">{{ d.clientName || '-' }}</div>
          </div>
          <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-800/50">
            <div class="text-xs text-slate-400 font-bold uppercase mb-1">วันที่สร้าง</div>
            <div class="font-bold text-slate-800 dark:text-slate-100">{{ d.createDate | date:'dd/MM/yyyy HH:mm' }}</div>
          </div>
          <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-800/50">
            <div class="text-xs text-slate-400 font-bold uppercase mb-1">จำนวนรหัส</div>
            <div class="font-black text-2xl text-amber-600">{{ d.qty }}</div>
          </div>
          <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-800/50">
            <div class="text-xs text-slate-400 font-bold uppercase mb-1">โควต้า</div>
            <div class="font-bold text-slate-800 dark:text-slate-100">{{ d.quotaName || '-' }}</div>
          </div>
          <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-800/50">
            <div class="text-xs text-slate-400 font-bold uppercase mb-1">ประเภทรถ</div>
            <div class="font-bold text-slate-800 dark:text-slate-100">{{ d.vehicleTypeName || '-' }}</div>
          </div>
          <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-800/50">
            <div class="text-xs text-slate-400 font-bold uppercase mb-1">ประเภทบัตร</div>
            <div class="font-bold text-slate-800 dark:text-slate-100">{{ d.cardTypeName || '-' }}</div>
          </div>
          <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-800/50">
            <div class="text-xs text-slate-400 font-bold uppercase mb-1">Subscription</div>
            <div class="font-bold text-slate-800 dark:text-slate-100">{{ d.subscriptionName || '-' }}</div>
          </div>
          <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-800/50 md:col-span-2">
            <div class="text-xs text-slate-400 font-bold uppercase mb-1">ช่วงวันที่บัตร</div>
            <div class="font-bold text-slate-800 dark:text-slate-100">
              {{ d.startDate | date:'dd/MM/yyyy' }} — {{ d.endDate | date:'dd/MM/yyyy' }}
            </div>
          </div>
          <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-800/50">
            <div class="text-xs text-slate-400 font-bold uppercase mb-1">ชนิด Advance</div>
            <div class="font-bold text-slate-800 dark:text-slate-100">{{ d.advanceKind || '-' }}</div>
          </div>
          <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-800/50">
            <div class="text-xs text-slate-400 font-bold uppercase mb-1">รหัสใช้ได้ (วัน)</div>
            <div class="font-bold text-slate-800 dark:text-slate-100">{{ d.activateExpireDays || 10 }}</div>
          </div>
        </div>

        <div *ngIf="d.remark" class="p-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 text-sm">
          <div class="text-xs text-slate-400 font-bold uppercase mb-1">หมายเหตุ</div>
          <div class="text-slate-700 dark:text-slate-200 whitespace-pre-wrap">{{ d.remark }}</div>
        </div>

        <!-- รหัส Activate -->
        <div *ngIf="isExecuted" class="space-y-3">
          <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
            <div>
              <h4 class="text-sm font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                <span class="material-icons text-base text-blue-500">qr_code</span>
                รหัส Activate ทั้งหมด
              </h4>
              <p *ngIf="activateCodes.length > 0" class="text-xs text-slate-500 mt-1">
                ใช้แล้ว {{ usedCodeCount }} · ยังไม่ใช้ {{ unusedCodeCount }} · รวม {{ activateCodes.length }} รหัส
              </p>
            </div>
            <button *ngIf="activateCodes.length > 0" type="button" (click)="exportExcel()" [disabled]="isExporting()"
              class="px-4 py-2 rounded-xl border border-emerald-200 dark:border-emerald-800 text-emerald-700 dark:text-emerald-400 text-sm font-bold hover:bg-emerald-50 dark:hover:bg-emerald-900/20 transition-colors disabled:opacity-50 flex items-center gap-2">
              <span class="material-icons text-base">download</span>
              Export Excel
            </button>
          </div>

          <div *ngIf="isLoadingCodes()"
            class="p-4 rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 flex items-center gap-3 text-sm text-slate-500">
            <div class="w-5 h-5 border-2 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
            กำลังโหลดรหัส activate...
          </div>

          <div *ngIf="!isLoadingCodes() && activateCodes.length === 0"
            class="p-8 rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 text-center text-slate-400 text-sm">
            ไม่พบรหัส activate
          </div>

          <div *ngIf="!isLoadingCodes() && activateCodes.length > 0"
            class="rounded-2xl border border-slate-100 dark:border-slate-700 overflow-hidden">
            <div class="max-h-72 overflow-y-auto custom-scrollbar">
              <table class="w-full text-sm text-left">
                <thead class="sticky top-0 bg-slate-50 dark:bg-slate-800 text-xs font-bold text-slate-400 uppercase">
                  <tr>
                    <th class="p-3 w-12">#</th>
                    <th class="p-3">รหัส Activate</th>
                    <th class="p-3">ช่วงบัตร</th>
                    <th class="p-3 text-center">สถานะ</th>
                    <th class="p-3">วันหมดอายุรหัส</th>
                    <th class="p-3">วันที่ Activate</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
                  <tr *ngFor="let code of activateCodes; let i = index"
                    class="hover:bg-slate-50/50 dark:hover:bg-slate-800/30">
                    <td class="p-3 text-slate-400 font-mono text-xs">{{ i + 1 }}</td>
                    <td class="p-3 font-mono font-bold text-slate-800 dark:text-slate-100 tracking-wide">{{ code.code }}</td>
                    <td class="p-3 text-xs text-slate-500 whitespace-nowrap">
                      {{ code.startDate | date:'dd/MM/yy' }} - {{ code.endDate | date:'dd/MM/yy' }}
                    </td>
                    <td class="p-3 text-center">
                      <span class="inline-flex px-2 py-0.5 rounded-full text-[11px] font-bold"
                        [ngClass]="code.isUsed
                          ? 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300'
                          : 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'">
                        {{ code.isUsed ? 'ใช้แล้ว' : 'ยังไม่ใช้' }}
                      </span>
                    </td>
                    <td class="p-3 text-xs text-slate-500 whitespace-nowrap">
                      {{ code.activateExpireAt ? (code.activateExpireAt | date:'dd/MM/yyyy HH:mm') : '-' }}
                    </td>
                    <td class="p-3 text-xs text-slate-500 whitespace-nowrap">
                      {{ code.activateDate ? (code.activateDate | date:'dd/MM/yyyy HH:mm') : '-' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div *ngIf="!isExecuted"
          class="p-5 rounded-2xl border border-dashed border-amber-200 dark:border-amber-800 bg-amber-50/40 dark:bg-amber-900/10 text-center text-sm text-amber-800 dark:text-amber-300">
          <span class="material-icons text-2xl mb-1 block text-amber-500">info</span>
          รหัส activate จะแสดงหลัง Gen Code (สถานะ "สร้างรหัสแล้ว")
        </div>
      </div>

      <div class="flex-none px-6 md:px-8 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-end">
        <button type="button" (click)="onClose()"
          class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
          ปิด
        </button>
      </div>
    </ng-container>
  </div>
</div>
